import { render } from "./Advancement.vue?vue&type=template&id=57752056"
import script from "./Advancement.vue?vue&type=script&lang=js"
export * from "./Advancement.vue?vue&type=script&lang=js"

import "./Advancement.vue?vue&type=style&index=0&id=57752056&lang=less"
script.render = render

export default script